import React, { useState, Fragment } from 'react';
import Header from './Header';

import { Link, useHistory, withRouter } from 'react-router-dom';
import './NewContact.css';

import TorontoFooter from '../Layout/TorontoFooter';
import { Helmet } from 'react-helmet';
import SFFooter from '../Layout/SFFooter';
import NYCFooter from '../Layout/NYCFooter';
import callIcon from '../../images/request-call.svg';
import emailIcon from '../../images/email-to.svg';
import OttawaFooter from '../Layout/OttawaFooter';

const NewContact = () => {
  const history = useHistory();
  const pathname = history.location.pathname;

  const [isEmail, setIsEmail] = useState();
  const [isCall, setIsCall] = useState();

  const toggleEmail = () => {
    setIsEmail(!isEmail);
  };

  const toggleCall = () => {
    setIsCall(!isCall);
  };

  return (
    <Fragment>
      <div className="contact" id="main">
        <Helmet>
          <title>Contact Us | Autzu</title>
          <meta name="description" />
        </Helmet>
        <Header
          persistentTitle
          title="Contact Us"
          back
          onClick={() => {
            history.goBack();
          }}
        />
        <div className="signup-form-container">
          <div className="download-title">Contact us</div>
          <div style={{ margin: '24px 0', fontSize: '18px' }}>
            Please choose one of the following methods to contact us.
          </div>
          <div className="options-container">
            <Link
              to={`${pathname}/email`}
              style={{ color: '#414141', textDecoration: 'none' }}>
              <div
                className="option-box"
                onClick={() => {
                  toggleEmail();
                }}>
                <img src={emailIcon} style={{ marginBottom: '12px' }} />
                <div>
                  Send us an email and we will get back to you in 24 hours.
                </div>
              </div>
            </Link>
            <Link
              to={`${pathname}/call`}
              style={{ color: '#414141', textDecoration: 'none' }}>
              <div
                className="option-box"
                onClick={() => {
                  toggleCall();
                }}>
                <img src={callIcon} style={{ marginBottom: '12px' }} />
                <div>
                  Request a call and join the waitlist. We will call you as
                  soon as possible.
                </div>
              </div>
            </Link>
          </div>
        </div>

        {pathname.includes('tor') ? (
          <TorontoFooter />
        ) : pathname.includes('sf') ? (
          <SFFooter />
        ) : pathname.includes('ott') ? (
          <OttawaFooter />
        ) : (
          <NYCFooter />
        )}
      </div>
    </Fragment>
  );
};

export default withRouter(NewContact);



// WEBPACK FOOTER //
// ./src/components/NewContact/NewContact.js